import { render, staticRenderFns } from "./email-item.vue?vue&type=template&id=7a246046"
import script from "./email-item.vue?vue&type=script&lang=js"
export * from "./email-item.vue?vue&type=script&lang=js"
import style0 from "./email-item.vue?vue&type=style&index=0&id=7a246046&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports